/**
 * Validation schemas of values that appear in API requests: the API rejects
 * what the web app's forms flag, with the same messages.
 */
import { z } from 'zod';
import { parseIsoDate } from './dates.js';
/** Calendar date "YYYY-MM-DD" that exists. */
export const isoDateSchema = z.string().refine((value) => {
    try {
        parseIsoDate(value);
        return true;
    }
    catch {
        return false;
    }
}, { message: 'Data non valida (formato AAAA-MM-GG)' });
/** Lower-cased e-mail address, as matched against the sign-in identity. */
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .pipe(z.email({ message: 'Indirizzo e-mail non valido' }));
/** Identifier of a database row. */
export const idSchema = z.uuid({ message: 'Identificativo non valido' });
/** A required single-line text, trimmed. */
export function requiredText(max) {
    return z
        .string()
        .trim()
        .min(1, { message: 'Campo obbligatorio' })
        .max(max, { message: `Al massimo ${max} caratteri` });
}
/** An optional single-line text, trimmed; empty becomes null. */
export function optionalText(max) {
    return z
        .string()
        .trim()
        .max(max, { message: `Al massimo ${max} caratteri` })
        .nullish()
        .transform((value) => (value ? value : null));
}
//# sourceMappingURL=validation.js.map